import { useState, useMemo, useEffect } from "react";
import "@/App.css";
import { createXRStore } from "@react-three/xr";
import { Toaster } from "@/components/ui/sonner";
import Scene from "@/sim/Scene";
import HUD from "@/sim/HUD";
import { startAudio } from "@/audio";
import { stressStore } from "@/store";
import { Sparkles } from "lucide-react";

function App() {
  const xrStore = useMemo(() => createXRStore(), []);
  const [entered, setEntered] = useState(
    typeof window !== "undefined" && new URLSearchParams(window.location.search).has("skipIntro")
  );

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const patch = {};
    ["phd", "budget", "funding"].forEach((k) => {
      if (p.has(k)) patch[k] = Math.min(1, Math.max(0, parseFloat(p.get(k)) || 0));
    });
    if (Object.keys(patch).length) stressStore.set(patch);
  }, []);

  const enter = () => {
    setEntered(true);
    try {
      startAudio();
      stressStore.set({ audioReady: true });
    } catch (e) {
      console.warn("audio unavailable", e);
    }
  };

  return (
    <div className="af-root" data-testid="af-root">
      <Scene xrStore={xrStore} />
      <div className="af-hud-layer">
        <HUD xrStore={xrStore} />
      </div>

      {!entered && (
        <div className="af-intro" data-testid="intro-overlay">
          <div className="af-intro-card">
            <span className="af-intro-kicker">
              <Sparkles size={14} /> Spatial Computing Exhibit
            </span>
            <h1 className="af-intro-title">Academic Feudalism</h1>
            <p className="af-intro-sub">
              A translucent gemstone pyramid mapping the modern higher-education labor hierarchy —
              from the ruby base of adjuncts to the gilded apex of administration.
            </p>
            <button className="af-intro-btn" onClick={enter} data-testid="enter-exhibit-btn">
              Enter the Exhibit
            </button>
            <span className="af-intro-note">Best experienced on Vision Pro or Meta Quest · WebXR ready</span>
          </div>
        </div>
      )}

      <Toaster position="bottom-center" theme="light" />
    </div>
  );
}

export default App;
